import { Button, Flex, RadioGroup, RadioGroupProps } from '@chakra-ui/react'

export type ButtonRadioOption = {
  label: string
  value: string
}

export type ButtonRadioProps<Options extends ButtonRadioOption[]> = Partial<
  Omit<RadioGroupProps, 'onChange' | 'value'>
> & {
  onChange: (value: Options[number]['value']) => void
  value?: Options[number]['value']
}

export const ButtonRadio = <Options extends ButtonRadioOption[]>({
  onChange,
  options,
  value,
  ...props
}: { options: Options } & ButtonRadioProps<Options>) => {
  return (
    <RadioGroup value={value} {...props}>
      <Flex
        border="1px solid"
        padding="3px"
        borderRadius="8px"
        borderColor="presets.neutral.30"
        backgroundColor="presets.neutral.0"
      >
        {options.map(option => {
          return (
            <Button
              role="radio"
              key={option.value}
              value={option.value}
              onClick={() => onChange(option.value)}
              borderRadius="6px"
              padding="6px 8px 7px"
              margin="0 -0.75px"
              fontSize="12px"
              lineHeight="15px"
              border="0"
              fontWeight={option.value === value ? '600' : '500'}
              color={
                option.value === value
                  ? 'presets.neutral.0'
                  : 'presets.neutral.80'
              }
              variant={option.value === value ? 'primary' : 'tertiary'}
              {...(option.value === value && {
                _hover: {},
              })}
            >
              {option.label}
            </Button>
          )
        })}
      </Flex>
    </RadioGroup>
  )
}
